import { useEffect, useRef } from 'react';
import { UserSession } from '../types';
import { verifyDeviceSession, subscribeDeviceSession, enforceKick } from '../services/sessionGuard';

// Active l'éjection mono-appareil pour tous les rôles SAUF superadmin.
export function useSingleDeviceSession(user: UserSession): void {
  const cleanup = useRef<null | (() => void)>(null);

  useEffect(() => {
    const stop = () => { cleanup.current?.(); cleanup.current = null; };

    if (!user.loggedIn || !user.userId) { stop(); return; }
    if (user.role === undefined) return;            // rôle pas encore chargé → on attend (l'effet re-run)
    if (user.role === 'superadmin') { stop(); return; }

    let alive = true;
    (async () => {
      const status = await verifyDeviceSession(user.userId!);
      if (!alive) return;
      if (status === 'superseded') { await enforceKick(); return; }
      cleanup.current = subscribeDeviceSession(user.userId!, () => { void enforceKick(); });
    })();

    return () => { alive = false; stop(); };
  }, [user.loggedIn, user.userId, user.role]);
}
